import { combineReducers } from 'redux'
import listReducer, { listActions } from '@app-store/slices/contacts/list'
import advancedListReducer, { advancedListActions } from '@app-store/slices/contacts/advancedList'
import assignedListReducer, { assignedListActions } from '@app-store/slices/contacts/assignedList'
import oneContactReducer, { oneContactActions } from '@app-store/slices/contacts/oneContact'
import editReducer, { editActions } from '@app-store/slices/contacts/edit'
import fileUploadReducer, { fileUploadActions } from '@app-store/slices/contacts/fileUpload'
import getPreSignedUploadURLReducer, {
    getPreSignedUploadURLActions
} from '@app-store/slices/contacts/getPreSignedUploadURL'
import contactViewReducer, { contactViewActions } from '@app-store/slices/contacts/view.slice'
import deleteContactReducer, { deleteContactActions } from '@app-store/slices/contacts/delete'
import moveToCompanyReducer, { moveToCompanyActions } from '@app-store/slices/contacts/moveToCompany'

export const contactsReducer = combineReducers({
    list: listReducer,
    advancedList: advancedListReducer,
    edit: editReducer,
    assignedList: assignedListReducer,
    oneContact: oneContactReducer,
    fileUpload: fileUploadReducer,
    getPreSignedUploadURL: getPreSignedUploadURLReducer,
    view: contactViewReducer,
    delete: deleteContactReducer,
    moveToCompany: moveToCompanyReducer
})

export const contactsActions = {
    list: listActions,
    advancedList: advancedListActions,
    edit: editActions,
    assignedList: assignedListActions,
    oneContact: oneContactActions,
    fileUpload: fileUploadActions,
    getPreSignedUploadURL: getPreSignedUploadURLActions,
    view: contactViewActions,
    delete: deleteContactActions,
    moveToCompany: moveToCompanyActions
}
